const polish = {
    'PHOTO_SOURCE.TakePhoto' : 'Zrób zdjęcie',
    'PHOTO_SOURCE.ChooseFromGallery' : 'Wybierz z galerii',
    'CRAFT.Type_Logistics' : 'Logistyka { number }',
    'CRAFT.Type_Floor' : 'Podloga { number }',
    'CRAFT.Type_Assembly' : 'Montaz { number }',
    'CRAFT.Type_Electrics' : 'Elektryka { number }',
    'CRAFT.Type_Graphic' : 'Grafika { number }',
    'CRAFT.Type_Furniture' : 'Meble { number }',
    'CRAFT.Type_Multimedia' : 'Multimedia { number }',
    'CRAFT.Type_Cleaning' : 'Sprzatanie { number }',
    'CRAFT.Type_Additional' : 'Dodatkowe { number }',
    'CRAFT.Type_MPControl' : 'Kontrola MP',
    'CRAFT.Type_Protocol' : 'Protokol',
    'CRAFT.Type_Service' : 'Serwis { number }',
    'CRAFT.Type_CollectGraphics' : 'Odbior grafiki',
    'CRAFT.Status_Text_InProgress' : 'W trakcie',
    'CRAFT.Status_Text_Disabled' : 'Wylaczone',
    'CRAFT.Status_Text_Completed' : 'Zakonczone',
    'CRAFT.Status_Text_Overdue' : 'Po terminie',
    'CRAFT.Status_Text_Done' : 'Odebrane',
    'CRAFT.Status_Text_Open' : 'Otwarte',
    'CRAFT.Status_Text_Collected': 'Odebrane',
    'CRAFT.Status_Warning_Cannot_Change_Done': 'Nie mozna zmienic statusu: grafika zostala juz przetworzona w panelu administracyjnym',
    'CRAFT.Button_ViewAll' : 'Pokaz wszystko',
    'CRAFT.Button_Text_Print' : 'Drukuj',
    'CRAFT.Button_Text_Stand' : 'Stoisko',
    'CRAFT.Button_Text_MarkOpen' : 'Oznacz prace jako otwarte',
    'CRAFT.Button_Text_MarkDone' : 'Oznacz prace jako wykonane',
    'CRAFT.Button_Text_MarkInProgress' : 'Oznacz prace jako w trakcie',
    'CRAFT.Button_ChangeStatus_InProgress' : 'W trakcie',
    'CRAFT.Button_ChangeStatus_Done': 'Gotowe',
    'CRAFT.Button_Text_ShelfNumber' : 'Nr polki',
    'CRAFT.Filter_Params_CraftType' : 'Prace: { withFilter }',
    'EXHIBITION.Select_Instruction' : 'Wybierz wydarzenie { br } z listy ponizej',
    'EXHIBITION.Select_Label' : 'WYBRANE WYDARZENIE',
    'EXHIBITION.Modal_Title' : 'WYBIERZ WYDARZENIE',
    'EXHIBITION.Timer_State_Underway' : 'W TRAKCIE',
    'EXHIBITION.Timer_State_Ended' : 'ZAKONCZONE',
    'EXHIBITION.Title_CraftTotal' : 'Podsumowanie wszystkich prac',
    'EXHIBITION.Statistic_Status_InTotal' : 'lacznie',
    'EXHIBITION.Statistic_Status_InProgress' : 'w trakcie',
    'EXHIBITION.Statistic_Status_Done' : 'gotowe',
    'EXHIBITION.Statistic_Status_Overdue' : 'po terminie',
    'EXHIBITION.Statistic_Status_NotApproved' : 'niezatwierdzone',
    'EXHIBITION.Statistic_Status_BookedForExhibition' : 'przypisani do wystawy',
    'EXHIBITION.Statistic_Status_CheckedIn' : 'Zameldowani',
    'EXHIBITION.Statistic_Type_Stands' : 'Stoiska',
    'EXHIBITION.Statistic_Type_Claims' : 'Zgloszenia MP',
    'EXHIBITION.Statistic_Type_CustomerClaims' : 'Zgloszenia wystawcy',
    'EXHIBITION.Statistic_Type_LastMinute' : 'Pilne zadania',
    'EXHIBITION.Statistic_Type_MpControl' : 'Kontrola MP',
    'EXHIBITION.Statistic_Type_Damages' : 'Szkody',
    'EXHIBITION.Statistic_Type_Protocol' : 'Protokol',
    'EXHIBITION.Statistic_Type_Staff' : 'Personel',
    'FORM.Textarea_Placeholder_JobDescription' : 'Opis zadania*',
    'FORM.Button_Text_AddJob' : 'Dodaj zadanie',
    'FORM.Button_Text_SaveJob' : 'Zapisz zadanie',
    'FORM.Button_AddJobPhoto' : 'Dodaj zdjecie',
    'FORM_RULES.Required_Login' : 'Wpisz login',
    'FORM_RULES.Required_Password' : 'Wpisz haslo',
    'FORM_RULES.Required_KeyDescription' : 'Wpisz opis klucza',
    'FORM_RULES.Required_KeyNumber' : 'Wpisz numer klucza',
    'FORM_RULES.Required_JobDescription' : 'Dodaj opis zadania',
    'FORM_RULES.Required_Quantity' : 'Wpisz ilosc',
    'FORM_RULES.Min_Quantity' : 'Ilosc musi byc liczba nie mniejsza niz jeden',
    'FORMS.Input_Label_Login' : 'login',
    'FORMS.Input_Label_Password' : 'haslo',
    'FORMS.Button_Text_Login' : 'Zaloguj',
    'FORMS.Input_Label_Description' : 'Opis',
    'FORMS.Input_Label_KeyNumber' : 'Numer klucza',
    'FORMS.Input_Label_Hall' : 'Hala',
    'FORMS.Input_Label_Stands' : 'Stoiska',
    'FORMS.Button_Text_ApplyFilters' : 'Zastosuj',
    'FORMS.Button_Text_ResetFilters' : 'Resetuj filtry',
    'FORMS.Select_DefaultValue_All' : 'Wszystko',
    'FORMS.Select_StandTypeValue_CraftInProgress' : 'Z pracami w trakcie',
    'FORMS.Select_StandTypeValue_CraftCompleted' : 'Z zakonczonymi pracami',
    'FORMS.Select_StandTypeValue_ControlInProgress' : 'Z kontrola w trakcie',
    'FORMS.Select_StandTypeValue_ProtocolInProgress' : 'Z protokolem w trakcie',
    'FORMS.Select_StandTypeValue_OverdueCrafts' : 'Z pracami po terminie',
    'FORMS.Select_StandTypeValue_AdditionalJobs' : 'Z dodatkowymi zadaniami',
    'FORMS.Button_Text_ApplySort' : 'Zastosuj',
    'FORMS.Input_Label_CraftType' : 'Typ prac',
    'FORMS.Input_Label_JobType'   : 'Typ',
    'FORMS.Input_Label_JobFlag'   : 'Flaga',
    'FORMS.Input_Label_JobStatus' : 'Status',
    'FORMS.Input_Label_CraftStatus' : 'Status prac',
    'FORMS.Input_Label_DamageStatus' : 'Status szkody',
    'FORMS.Input_Label_Subcontractor' : 'Podwykonawca',
    'FORMS.Input_Label_Comments' : 'Komentarze',
    'FORMS.Select_JobStatusValue_JobsOpen' : 'Otwarte zadania',
    'FORMS.Select_JobStatusValue_JobsInProgress' : 'Zadania w trakcie',
    'FORMS.Select_JobStatusValue_FinishedJobs' : 'Zakonczone zadania',
    'FORMS.Select_JobFlag_WithoutFlag' : 'Bez flagi',
    'FORMS.Select_JobFlag_WithFlag' : 'Z flaga',
    'FORMS.Input_Label_FurnishingName' : 'Nazwa wyposazenia',
    'FORMS.Input_Label_FurnishingReturnQuantity' : 'Ilosc',
    'FORMS.Input_Label_Quantity' : 'Ilosc',
    'FORMS.Input_Label_CurrentQuantity' : 'Aktualna ilosc',
    'FORMS.Input_Label_NewQuantity' : 'Nowa ilosc',
    'FORMS.RadioInput_Text_Description' : 'Opis',
    'FORMS.RadioInput_Text_Furnishing' : 'Wyposazenie',
    'FORMS.RadioInput_Text_FurnishingClaim' : 'Wyposazenie',
    'FORMS.Input_Label_OrderType'   : 'Typ',
    'FORMS.Select_FurnishingOrder_Type_Return' : "Zwrot artykulu",
    'FORMS.Select_FurnishingOrder_Type_Lost' : "Zagubione",
    'FORMS.Select_FurnishingOrder_Type_Correction' : "Zmiana sumy",
    'FORMS.Select_FurnishingOrder_Type_Order' : "Zamowienie",
    'GLOBAL.Button_Text_Logout' : 'Wyloguj',
    'GLOBAL.Button_Text_Filter' : 'Filtr',
    'GLOBAL.Button_Text_Sort' : 'Sortuj',
    'GLOBAL.Text_Version' : 'Wersja { versionNumber }',
    'GLOBAL.Button_Text_Cancel' : 'Anuluj',
    'ATTENDANCE.Button_CheckIn': 'Wejście',
    'ATTENDANCE.Button_CheckOut': 'Wyjście',
    'ATTENDANCE.SelectExhibitionFirst_Text': 'Najpierw wybierz wystawę.',
    'ATTENDANCE.Button_RetryScan': 'Skanuj ponownie',
    'ATTENDANCE.Button_Close': 'Zamknij',
    'ATTENDANCE.Modal_Title_CheckIn': 'Skanuj wejście',
    'ATTENDANCE.Modal_Title_CheckOut': 'Skanuj wyjście',
    'ATTENDANCE.Scanner_Hint': 'Skieruj kamerę na kod QR',
    'ATTENDANCE.Processing_Locating_Title': 'Sprawdzanie lokalizacji...',
    'ATTENDANCE.Processing_Locating_Text': 'Proszę czekać. Szukanie GPS.',
    'ATTENDANCE.Processing_Submitting_Title': 'Wysyłanie skanu...',
    'ATTENDANCE.Processing_Submitting_Text': 'Proszę czekać. Zapisywanie czasu pracy.',
    'ATTENDANCE.Error_GpsPermission_Title': 'Wymagany dostęp do lokalizacji',
    'ATTENDANCE.Error_GpsPermission_Text': 'Zezwól na dostęp do lokalizacji w przeglądarce i spróbuj ponownie.',
    'ATTENDANCE.Error_GpsTimeout_Title': 'Słaby sygnał GPS',
    'ATTENDANCE.Error_GpsTimeout_Text': 'Nie znaleziono współrzędnych. Podejdź bliżej wyjścia i zeskanuj ponownie.',
    'ATTENDANCE.Error_GpsUnavailable_Title': 'GPS niedostępny',
    'ATTENDANCE.Error_GpsUnavailable_Text': 'Dane lokalizacji nie są dostępne na tym urządzeniu.',
    'ATTENDANCE.Error_Camera_Title': 'Kamera niedostępna',
    'ATTENDANCE.Error_Camera_Text': 'Zezwól na dostęp do kamery i spróbuj ponownie.',
    'ATTENDANCE.Error_CameraPermission_Title': 'Dostęp do kamery zablokowany',
    'ATTENDANCE.Error_CameraPermission_Text': 'Zezwól na dostęp do kamery w ustawieniach strony w przeglądarce i spróbuj ponownie.',
    'ATTENDANCE.Error_CameraNotFound_Title': 'Nie znaleziono kamery',
    'ATTENDANCE.Error_CameraNotFound_Text': 'To urządzenie nie udostępnia przeglądarce dostępnej kamery.',
    'ATTENDANCE.Error_SecureContext_Title': 'Wymagany HTTPS',
    'ATTENDANCE.Error_SecureContext_Text': 'Kamera i GPS w przeglądarce mobilnej działają tylko przez HTTPS. Otwórz aplikację przez tunel deweloperski HTTPS.',
    'ATTENDANCE.Error_Server_Title': 'Skan nie powiódł się',
    'ATTENDANCE.Error_Server_Text': 'Serwer nie przetworzył skanu. Sprawdź połączenie z Internetem i spróbuj ponownie.',
    'ATTENDANCE.Error_Generic_Title': 'Skan nie powiódł się',
    'ATTENDANCE.Error_Generic_Text': 'Spróbuj ponownie.',
    'ATTENDANCE.Result_CheckInAccepted_Title': 'Wejście zapisane',
    'ATTENDANCE.Result_CheckOutAccepted_Title': 'Wyjście zapisane',
    'ATTENDANCE.Result_Accepted_Text': 'Czas: { serverTime }. Zapisano Cię w systemie.',
    'ATTENDANCE.Result_Duplicate_Title': 'Już zapisano',
    'ATTENDANCE.Result_Duplicate_Text': 'Ten skan został już zapisany.',
    'ATTENDANCE.Result_Rejected_Title': 'Dostęp odrzucony',
    'ATTENDANCE.Result_OutsideRadius_Text': 'Jesteś zbyt daleko od wejścia. Podejdź bliżej wejścia.',
    'ATTENDANCE.Result_InvalidQr_Text': 'Ten kod QR nie jest ważny dla wejścia/wyjścia.',
    'ATTENDANCE.Result_GenericRejected_Text': 'Skan został odrzucony.',
    'ATTENDANCE.Button_Back': 'Wstecz',
    'ATTENDANCE.Button_TryAgain': 'Spróbuj ponownie',
    'ATTENDANCE.Button_GotIt': 'Rozumiem',
    'ATTENDANCE.Overview_NotCheckedIn': 'Brak zameldowania',
    'ATTENDANCE.Overview_CheckInPrompt': 'Zamelduj się, skanując kod QR',
    'ATTENDANCE.Overview_CheckedIn_Label': 'Zameldowano',
    'ATTENDANCE.Overview_CheckedInAt': 'o { time }',
    'ATTENDANCE.Scanner_CheckIn_Hint': 'Przed rozpoczęciem pracy zeskanuj kod QR, aby się zameldować',
    'ATTENDANCE.Scanner_CheckOut_Hint': 'Aby się wymeldować, skieruj kamerę na kod QR na wystawie',
    'ATTENDANCE.Error_StatusLoad_Text': 'Nie udało się wczytać statusu zameldowania.',
    'ATTENDANCE.Error_CameraDesign_Title': 'Aplikacja nie może otworzyć kamery',
    'ATTENDANCE.Error_CameraDesign_Text': 'Aby się zameldować, zeskanuj kod aparatem telefonu. Naciśnij Spróbuj ponownie i zezwól na dostęp do kamery.',
    'ATTENDANCE.Error_Camera_Settings_Hint': 'Nadal nie działa? Kamera może być zablokowana — sprawdź uprawnienia witryny w przeglądarce.',
    'ATTENDANCE.Error_LocationDesign_Title': 'Aplikacja nie widzi Twojej lokalizacji',
    'ATTENDANCE.Error_LocationDesign_Text': 'Do zameldowania potrzebna jest lokalizacja. Włącz ją w ustawieniach telefonu i spróbuj ponownie.',
    'ATTENDANCE.Result_CheckedInAt': 'Zameldowano o { time }',
    'ATTENDANCE.Result_CheckInSuccessAt': 'Pomyślnie zarejestrowano rozpoczęcie pracy o { time }.',
    'ATTENDANCE.Result_CheckedOutAt': 'Praca została zakończona, a wyjście{ br }zarejestrowano o { time }',
    'ATTENDANCE.Result_OutsideRadius_Title': 'Musisz być na miejscu wydarzenia',
    'ATTENDANCE.Result_OutsideRadius_DesignText': 'Twoja lokalizacja nie odpowiada wystawie. Zameldowania są rejestrowane przez GPS. Spróbuj ponownie na miejscu.',
    'ATTENDANCE.Result_InvalidQr_Title': 'To nie jest właściwy kod',
    'ATTENDANCE.Result_InvalidQr_CheckIn_Title': 'Zameldowanie niemożliwe!',
    'ATTENDANCE.Result_InvalidQr_CheckOut_Title': 'Wymeldowanie niemożliwe!',
    'ATTENDANCE.Result_InvalidQr_DesignText': 'Ten kod QR nie należy do Twojego wydarzenia. Skontaktuj się z kierownictwem budowy lub projektu.',
    'ATTENDANCE.Result_DeviceConflict_Title': 'Zameldowanie niemożliwe!',
    'ATTENDANCE.Result_DeviceConflict_Text': 'Inna osoba zarejestrowała już rozpoczęcie pracy za pomocą tego telefonu. Aplikacja nie pozwala dwóm różnym użytkownikom rejestrować rozpoczęcia pracy na tym samym urządzeniu!',
    'ATTENDANCE.Result_OutsideSchedule_CheckIn_Title': 'Nie można wykonać skanu podczas zameldowania!',
    'ATTENDANCE.Result_OutsideSchedule_CheckIn_Text': 'Zameldowanie jest możliwe tylko w wyznaczonym okresie trwania wydarzenia. Skontaktuj się z kierownictwem budowy lub projektu.',
    'ATTENDANCE.Result_OutsideSchedule_CheckOut_Title': 'Wymeldowanie nie jest teraz dostępne',
    'ATTENDANCE.Result_OutsideSchedule_Text': 'Ta czynność jest dostępna tylko w skonfigurowanym okresie wystawy. Sprawdź wybraną wystawę i jej daty.',
    'ATTENDANCE.TimeRecords_InProgress': 'w trakcie',
    'ATTENDANCE.TimeRecords_Missed': 'pominięto',
    'ATTENDANCE.TimeRecords_Empty': 'Brak zapisów czasu pracy.',
    'ATTENDANCE.Error_TimeRecordsLoad_Text': 'Nie udało się wczytać zapisów czasu pracy.',
    'MENUS.Label_MyTimeRecords': 'Mój czas pracy',
    'PAGE.Title_MyTimeRecords': 'Mój czas pracy',
    'GLOBAL.Badge_Text_New' : 'NOWE',
    'GLOBAL.Modal_Title_Filters' : 'Filtry',
    'GLOBAL.Modal_Title_SortBy' : 'Sortuj wedlug',
    'GLOBAL.TimeLeft' : 'pozostalo { timeLeft }',
    'GLOBAL.Text_Piece' : 'szt.',
    'GLOBAL.Button_Text_Confirm' : 'Potwierdz',
    'GLOBAL.Language_Default' : 'Domyslny',
    'TRANSLATION.Button_Text_Translate' : 'Przetlumacz',
    'TRANSLATION.Button_Text_TranslateInput' : 'Przetlumacz na niemiecki',
    'TRANSLATION.Button_Text_TranslateEnglish' : 'Przetlumacz na angielski',
    'TRANSLATION.Button_Text_TranslateNative' : 'Przetlumacz na moj jezyk',
    'TRANSLATION.Button_Text_ShowOriginal' : 'Pokaz oryginal niemiecki',
    'TRANSLATION.Text_InputTranslating' : 'Tlumaczenie...',
    'TRANSLATION.Text_InputTranslated' : 'Przetlumaczono',
    'TRANSLATION.Text_InputTranslationError' : 'Tlumaczenie nie powiodlo sie',
    'TRANSLATION.Text_InputTranslationRequired' : 'Przetlumacz tekst przed wyslaniem',
    'TRANSLATION.Text_ApiUnavailable' : 'Tlumaczenie jest teraz niedostepne',
    'GLOBAL.Card_Hero_Hall' : 'Hala',
    'GLOBAL.Card_Hero_Block' : 'Blok',
    'GLOBAL.Card_Hero_Stand' : 'Stoisko',
    'GLOBAL.Comment': 'Komentarz',
    'HALL.Button_Text_HallPlan' : 'Plan hali',
    'HALL.Link_Text_HallPlan' : 'Plan hali { hallName }',
    'JOB.Tag_Claim' : 'C',
    'JOB.Tag_CustomerClaim' : 'C',
    'JOB.Tag_MPAndCustomerClaim' : 'C',
    'JOB.Tag_LastMinute' : 'LM',
    'JOB.Tag_Damage' : 'D',
    'JOB.Tag_ProtocolDefect' : 'PD',
    'JOB.Card_Hero_Hall' : 'Hala',
    'JOB.Card_Hero_Number' : 'Nr zadania',
    'JOB.Card_Hero_Block' : 'Blok',
    'JOB.Card_Hero_Stand' : 'Stoisko',
    'JOB.Card_Hero_Exhibitor' : 'Wystawca',
    'JOB.Button_Text_ToTheStand' : 'Do stoiska',
    'JOB.Text_Creator' : 'przez { whoCreate } dnia { whenCreate }',
    'JOB.Text_InWork' : 'przez { whoWork } dnia { whenWork }',
    'JOB.Text_Executor' : 'przez { whoExecute } dnia { whenExecute }',
    'JOB.Text_DurationTime' : 'Czas trwania: { time }',
    'JOB.Type_Claim' : 'Zgloszenie MP',
    'JOB.Type_AllClaims' : 'Zgloszenie',
    'JOB.Type_CustomerClaim' : 'Zgloszenie wystawcy',
    'JOB.Type_LastMinute' : 'Pilne zadanie',
    'JOB.Type_Damage' : 'Szkoda',
    'JOB.Type_ProtocolDefect' : 'Usterka w protokole',
    'JOB.Button_ChangeStatus_Waiting' : 'Przejmij zadanie',
    'JOB.Button_ChangeStatus_InProgress' : 'Zadanie w trakcie',
    'JOB.Button_ChangeStatus_Done' : 'Zakoncz zadanie',
    'JOB.Modal_Title_Photo' : 'Zdjecie zadania',
    'JOB.Filter_Params_JobType' : 'Typ: { withFilter }',
    'JOB.Filter_Params_CraftType' : 'Prace: { withFilter }',
    'JOB.Modal_Title_NewJob' : 'Nowe { jobType }',
    'JOB.Modal_Title_EditJob' : 'Edytuj { jobType }',
    'JOB.Button_Text_AddClaim' : 'Dodaj zadanie zgloszenia MP',
    'JOB.Button_Text_AddCustomerClaim' : 'Dodaj zadanie zgloszenia wystawcy',
    'JOB.Button_Text_AddLastMinute' : 'Dodaj pilne zadanie',
    'JOB.Button_Text_AddDamage' : 'Dodaj zdjecie szkody',
    'JOB.Button_Text_AddProtocolDefect' : 'Dodaj usterke protokolu',
    'DAMAGE.Card_Title' : 'Szkody u { exhibitor }',
    'DAMAGE.Modal_Title_Photo' : 'Szkody { exhibitor }',
    'DAMAGE.Status_Label_New' : 'Niesprawdzone',
    'DAMAGE.Status_Label_Check' : 'Sprawdzone',
    'DAMAGE.Status_Label_DCheck' : 'Zatwierdzone',
    'DAMAGE.Button_Text_Stand' : 'Stoisko',
    'DAMAGE.Button_Text_Photo' : 'Zdjecie',
    'DAMAGE.Button_Text_AddNote' : "DODAJ NOTATKE",
    'DAMAGE.Modal_Button_AddPhoto' : 'Dodaj zdjecie',
    'DAMAGE.Modal_Button_CreateReport' : 'Utworz raport',
    'DAMAGE.Modal_Button_EditReport' : 'Edytuj raport',
    'DAMAGE.AsCraft_label' : "Szkody",
    "DAMAGE.Button_Text_Open" : "Otworz",
    "STAND.Block_Title_Damages" : "Szkody",
    'MENUS.Label_Overview' : 'Przeglad',
    'MENUS.Label_Stands' : 'Stoiska',
    'MENUS.Label_Jobs' : 'Zadania',
    'MENUS.Label_ExpoPlan' : 'Plan expo',
    'MENUS.Label_More' : 'Wiecej',
    'MENUS.Label_SelectExhibition' : 'Wybierz wydarzenie',
    'MENUS.Label_CraftsOverview' : 'Przeglad prac',
    'MENUS.Label_HallsOverview' : 'Przeglad hal',
    'MENUS.Label_ViewDamages' : 'Zobacz szkody',
    'MENUS.Label_Downloads' : 'Pliki',
    'MENUS.Label_Documents' : 'Dokumenty',
    'MENUS.Label_FurnishingLeftovers' : 'Pozostale wyposazenie',
    'MENUS.Label_HelpImprint' : 'Imprint',
    'MENUS.Label_CollectGraphics' : 'Odbior grafiki',
    'NO_DATA.Exhibitions' : 'Nie masz jeszcze zadnych wydarzen.',
    'NO_DATA.Documents' : 'To wydarzenie nie ma jeszcze { br } zadnych dokumentow.',
    'NO_DATA.Stands' : 'Nie znaleziono stoisk pasujacych do zapytania { br }',
    'NO_DATA.StandPhoto' : 'Nie masz jeszcze zdjecia stoiska',
    'NO_DATA.DamagePhoto' : 'Nie masz jeszcze zdjec szkod { br } tego stoiska',
    'NO_DATA.Stand_NoKeys' : 'To stoisko nie ma jeszcze zadnych kluczy',
    'NO_DATA.Stand_DoesNotExist' : 'To stoisko nie istnieje',
    'NO_DATA.Subcontractor_Unsigned' : 'Nieprzypisany',
    'NO_DATA.Jobs' : 'Nie znaleziono zadan pasujacych do zapytania { br }',
    'NO_DATA.Damages' : 'Nie znaleziono szkod pasujacych do zapytania { br }',
    'NO_DATA.Hall' : 'Ta hala nie istnieje',
    'NO_DATA.HallPlan' : 'Nie znaleziono planu tej hali',
    'NO_DATA.Furnishing_Storage' : 'To wydarzenie nie ma { br } wyposazenia w magazynie',
    'NO_DATA.Furnishing_Orders' : 'To wydarzenie nie ma { br } zamowien wyposazenia',
    'PAGE.Title_Overview' : 'Przeglad',
    'PAGE.Title_ExhibitionSelection' : 'Wybor wydarzenia',
    'PAGE.Title_Stands' : 'Stoiska',
    'PAGE.Title_Stand' : 'Stoisko',
    'PAGE.Title_StandComments' : 'Komentarze stoiska',
    'PAGE.Title_StandLog' : 'Log stoiska',
    'PAGE.Title_StandKeys' : 'Klucze stoiska',
    'PAGE.Title_ViewDamages' : 'Zobacz szkody',
    'PAGE.Title_AdditionalMenu' : 'Dodatkowe menu',
    'PAGE.Title_Jobs' : 'Zadania',
    'PAGE.Title_ExpoPlan' : 'Plan expo',
    'PAGE.Title_Documents' : 'Dokumenty',
    'PAGE.Title_FurnishingLeftovers' : 'Wyposazenie LM',
    'PAGE.Title_FurnishingReturns' : 'Dziennik zmian wyposazenia',
    'PAGE.Title_HallPlan' : 'Plan hali',
    'PAGE.Title_HallsOverview' : 'Przeglad hal',
    'PAGE.Title_CraftsOverview' : 'Przeglad prac',
    'PAGE.Title_HelpImprint' : 'Imprint',
    'PAGE.Title_CollectGraphics' : 'Odbior grafiki',
    'SORT.Text_NewestByCreation' : 'Najnowsze wedlug daty utworzenia',
    'SORT.Text_OldestByCreation' : 'Najstarsze wedlug daty utworzenia',
    'SORT.Text_ExhibitorNameAZ' : 'Nazwa wystawcy (A-Z)',
    'SORT.Text_ExhibitorNameZA' : 'Nazwa wystawcy (Z-A)',
    'SORT.Text_FinishedFirst' : 'Najpierw zakonczone',
    'SORT.Text_InProgressFirst' : 'Najpierw otwarte',
    'SORT.Text_StandNumberAZ' : 'Numer stoiska (A-Z)',
    'SORT.Text_StandNumberZA' : 'Numer stoiska (Z-A)',
    'SORT.Text_CorridorAZ' : 'Korytarz (A-Z)',
    'SORT.Text_CorridorZA' : 'Korytarz (Z-A)',
    'SORT.Text_BlockAZ' : 'Blok (A-Z)',
    'SORT.Text_BlockZA' : 'Blok (Z-A)',
    'SORT.Text_FlagFirst' : 'Najpierw z flaga',
    'SORT.Text_FlagLast' : 'Najpierw bez flagi',
    'SORT.Text_HallAZ' : 'Hala (A-Z)',
    'SORT.Text_HallZA' : 'Hala (Z-A)',
    'SORT.Text_StatusAZ' : 'Zatwierdzone',
    'SORT.Text_StatusZA' : 'Niesprawdzone',
    'STAND.Modal_Title_Search' : 'Szukaj',
    'STAND.Input_Placeholder_Search' : 'Szukaj',
    'STAND.Filter_Params_Exhibitor' : 'Wystawca: { exhibitorName }',
    'STAND.Filter_Params_WithComments' : 'Z komentarzami',
    'STAND.Card_Hero_Hall' : 'Hala',
    'STAND.Card_Hero_Block' : 'Blok',
    'STAND.Card_Hero_Stand' : 'Stoisko',
    'STAND.Card_Hero_DeliveryTime' : 'Czas dostawy',
    'STAND.Modal_Title_StandPlan' : 'Rysunek stoiska',
    'STAND.Modal_Button_StandPlan' : 'Rysunek',
    'STAND.Card_Button_Details' : 'Szczegoly { icon }',
    'STAND.Modal_Title_StandPhoto' : 'Zdjecie stoiska',
    'STAND.Modal_Button_StandPhoto' : 'Zdjecie',
    'STAND.Modal_Button_SavePhoto' : 'Zapisz zdjecie',
    'STAND.Modal_Button_AddPhoto' : 'Dodaj zdjecie',
    'STAND.Button_Text_Comments' : 'Komentarze',
    'STAND.Button_Text_AddComment' : 'Dodaj komentarz',
    'STAND.Modal_Title_AddComment' : 'Dodaj komentarz',
    'STAND.Modal_Title_EditComment' : 'Edytuj komentarz',
    'STAND.Modal_Button_AddComment' : 'Dodaj',
    'STAND.Modal_Button_SaveComment' : 'Zapisz',
    'STAND.Text_NoComments' : 'Nie ma jeszcze komentarzy',
    'STAND.Text_AddFile' : 'Dodaj plik',
    'COMMENTS.Text_Uploading' : 'Przesylanie...',
    'STAND.Text_EditComment' : 'Edytuj',
    'STAND.Text_DeleteComment' : 'Usun',
    'STAND.Text_CommentDraftError' : 'Szkic komentarza nie jest jeszcze gotowy',
    'STAND.Block_Title_Overview' : 'Przeglad',
    'STAND.Block_Title_Materials' : 'Informacje dodatkowe',
    'STAND.Block_Title_Crafts' : 'Prace',
    'STAND.Block_ItemTitle_Hall' : 'Hala',
    'STAND.Block_ItemTitle_Block' : 'Blok',
    'STAND.Block_ItemTitle_Stand' : 'Stoisko',
    'STAND.Block_ItemTitle_ProaufNumber' : 'Numer Proauf',
    'STAND.Block_ItemTitle_Jobs' : 'Zadania',
    'STAND.Block_Item_JobCountInProgress' : '{ jobCount } w trakcie',
    'STAND.Block_Item_JobCountOpen' : '{ jobCount } otwarte',
    'STAND.Block_Item_JobCountFinished' : '{ jobCount } zakonczone',
    'STAND.Block_Button_ViewStandJobs' : 'Zobacz zadania stoiska',
    'STAND.Modal_Title_StandGraphic' : 'Grafika stoiska',
    'STAND.Modal_Button_StandGraphic' : 'Grafika stoiska',
    'STAND.Modal_Title_ExtraInfo' : 'Dodatkowe info',
    'STAND.Modal_Button_ExtraInfo' : 'Dodatkowe info',
    'STAND.Button_Text_ViewKeys' : 'Zobacz klucze',
    'STAND.Button_Text_ViewLogs' : 'Zobacz logi',
    'STAND.Modal_Button_AddKey' : 'Dodaj klucz',
    'STAND.Modal_Title_AddKey' : 'Dodaj klucz',
    'STAND.Modal_Title_EditKey' : 'Edytuj klucz',
    'STAND.Modal_Button_UpdateKey' : 'Aktualizuj klucz',
    'STAND.Filter_Params_Stand' : 'Stoisko { withFilter }',
    'STAND.Button_Text_DeleteKey' : 'Usun',
    'STAND.Text_ModalDelete_Question' : 'Czy na pewno chcesz usunac klucz { keyName }?',
    'STAND.External_Exhibition' : 'Wydarzenie, do ktorego nie jestes przypisany',
    'JOB.Button_Text_ViewPhoto' : 'Zobacz zdjecie',
    'OVERVIEW_TYPES.Label_InTotal' : 'lacznie',
    'OVERVIEW_TYPES.Label_Finished' : 'zakonczone',
    'OVERVIEW_TYPES.Label_Open' : 'otwarte',
    'OVERVIEW_TYPES.Label_Claims' : 'zgloszenia',
    'OVERVIEW_TYPES.Label_LastMinute' : 'pilne',
    'OVERVIEW_TYPES.Label_Overdue' : 'po terminie',
    'FURNISHING.TabName_Storage' : 'Magazyn',
    'FURNISHING.TabName_Refund' : 'Zwroty',
    'FURNISHING.TabName_OrderLog' : 'Dziennik zamowien',
    'FURNISHING.Modal_Title_ReturnFurnishing' : 'Ilosci wyposazenia LM',
    'FURNISHING.Modal_Title_FurnishingStore' : 'Wyposazenie w magazynie',
    'FURNISHING.Button_Text_Return' : 'Zwrot',
    'FURNISHING.Button_Text_ChooseFurnishing' : 'Wybierz wyposazenie',
    'FURNISHING.Modal_Title_Photo' : "Zdjecie wyposazenia",
    'FURNISHING.Order_Type_Refund' : "Zwrot",
    'FURNISHING.Order_Type_Lost' : "Zagubione",
    'FURNISHING.Order_Type_Correction' : "Korekta",
    'FURNISHING.Order_Type_Order' : "Zamowienie",
};

export default polish;
